import React from 'react';
import './Industrial.css';
import primaryBackground from '../Assets/industrialenginnering.jpg'; // Replace with your primary background image

const Industrial = () => {
  return (
    <div
      className="industrial-container"
      style={{
        backgroundImage: `url(${primaryBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <img src={primaryBackground} alt="Industrial primary background" style={{ display: 'none' }} />
      <div className="secondary-bg"></div>
      <div className="content-section">
        <div className="content-inner">
          <h1>Industrial Solutions</h1>
          <p>
            
      Nous optimisons les processus, les flux de production et l’aménagement des installations afin d’améliorer la productivité et la performance globale. Notre approche vise l’efficacité, la réduction des coûts et l’amélioration continue
          </p>
        </div>
      </div>
    </div>
  );
};

export default Industrial;